import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Note = ({
  height = 24,
  width = 24,
  backgroundColor = colors.mustard20,
  color = colors.mustard100,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    {/* outline */}
    <path
      d="M13.2218 20.4375H4.6875C4.38913 20.4375 4.10298 20.319 3.892
      20.108C3.68103 19.897 3.5625 19.6109 3.5625 19.3125V4.6875C3.5625
      4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625
      4.6875 3.5625H19.3125C19.6109 3.5625 19.897 3.68103 20.108 3.892C20.319
      4.10298 20.4375 4.38913 20.4375 4.6875V13.2218C20.4374 13.5199 20.319
      13.8059 20.1082 14.0168L14.0168 20.1082C13.8059 20.319 13.5199 20.4374
      13.2218 20.4375Z"
      fill={backgroundColor}
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* bent corner */}
    <path
      d="M13.6875 20.3362V14.8125C13.6875 14.5141 13.806 14.228 14.017
      14.017C14.228 13.806 14.5141 13.6875 14.8125 13.6875H20.3362"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0625 8.0625H17.0625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0625 11.4375H12"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
